import { CellProps, WithClassname } from '@jsonforms/core';
import { Checkbox } from 'antd';
import merge from 'lodash/merge';

type AntdCheckboxProps = {
  label?: string;
  required?: boolean;
};
export const AntdCheckbox = (
  props: CellProps & WithClassname & AntdCheckboxProps
) => {
  const {
    data,
    id,
    enabled,
    label,
    uischema,
    path,
    handleChange,
    config,
    required,
  } = props;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);

  // `stacked` variant (schema's `options.variant`) renders a clean `☐ label`;
  // default is the original label-on-the-left layout.
  if (appliedUiSchemaOptions.variant === 'stacked') {
    return (
      <Checkbox
        checked={!!data}
        onChange={e => handleChange(path, e.target.checked)}
        id={id}
        disabled={!enabled}
        autoFocus={!!appliedUiSchemaOptions.focus}
        className='py-1 text-1420'
      >
        {label}
      </Checkbox>
    );
  }

  return (
    <label className='flex flex-row-reverse justify-end bg-transparent pl-0 pt-1.5'>
      <p className='min-w-[48%] pr-1 text-1420 font-regular'>
        {label}
        <span className='text-redOrange'>{required && ' *'}</span>
      </p>

      <Checkbox
        checked={!!data}
        onChange={e => handleChange(path, e.target.checked)}
        id={id}
        disabled={!enabled}
        autoFocus={!!appliedUiSchemaOptions.focus}
        className=' items-center justify-end pr-1.5'
      />
    </label>
  );
};
